module.exports = __webpack_public_path__ + "images/c712424074b17e6b4c2512f737fe6ed0.gif";